import { Button } from '@/components/ui-kit/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui-kit/card';
import { Link, useNavigate } from 'react-router-dom';

import { ArrowLeft, Settings } from 'lucide-react';

import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/state/store/auth';
import { Template } from '../../types/templates.types';

const DocxNoScreens = ({ template }: { template: Template }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const orgId = useAuthStore((state) => state.orgId);

  const configureHref = `/org/${orgId}/templates/${template.id}/docx`;
  const browseHref = `/org/${orgId}/templates`;

  return (
    <div className="container max-w-4xl py-16 mx-auto">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 text-sm text-globe-grey hover:text-selise-blue mb-8 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('TEMPLATES_GENERATEPAGE_BACKTOTEMPLATES')}
      </button>

      <Card className="border-border">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-[hsl(var(--selise-blue)/0.1)] flex items-center justify-center mb-4">
            <Settings className="h-8 w-8 text-selise-blue-500" />
          </div>
          <CardTitle className="text-2xl font-bold text-[hsl(var(--fg))]">
            {template.title}
          </CardTitle>
          <CardDescription className="text-base max-w-xl mx-auto">
            {template.description}
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <p className="text-globe-grey max-w-md mx-auto">
            No Variables are configured for this template. Please configure the variables in order
            to generate the document
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              asChild
              className="bg-selise-blue-500 hover:bg-selise-blue-500/90 text-white hover:text-white"
            >
              <Link to={configureHref}>
                <Settings className="h-4 w-4 mr-2" />
                {t('TEMPLATES_GENERATEPAGE_CONFIGUREFORM')}
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to={browseHref}>{t('TEMPLATES_GENERATEPAGE_BROWSETEMPLATES')}</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DocxNoScreens;
